import { LinearProgress } from '@mui/material'

export const Loading = () => <LinearProgress variant="indeterminate" />
